import { Image } from './Image'
import { Video } from './Video'
import type { ImageConfig, VideoConfig} from './types';
import { isImage } from './types'

export interface MediaProps {
  src: string
  config: ImageConfig | VideoConfig
}

export const Media = ({ src, config }: MediaProps) => {
  return isImage(config) ? <Image src={src} config={config} /> : <Video src={src} config={config} />
}
